import { useNetworkStatus } from '@/hooks/useNetworkStatus';
import { Alert } from '@pptcreate/ui';

export function OfflineBanner() {
  const online = useNetworkStatus();

  if (online) {
    return null;
  }

  return (
    <div className="sticky top-0 z-50 border-b-2 border-brut-border">
      <Alert variant="error" role="status" aria-live="assertive">
        You are offline. Changes may not save until your connection returns.
      </Alert>
    </div>
  );
}
